// apps/client/src/net/handlers/villagers.ts (M2-T11) — the snapshot's villagers and today's talk pauses, villager.* events, arrival and
// departure toasts, and the cream tags over villager houses (rev 9 item 3), in their own group so M0-T18's resident tags are never touched.
import { villagerSpace } from '@whiskerton/shared';
import { villagerHouseTags } from '../../characters/villagers';
import type { Game, NetHandlers } from '../../game/game';
import { useGame } from '../../state/store';

/** Cream tags over villager houses outdoors; none indoors, back on return. */
function syncVillagerHouseTags(game: Game): void {
  const s = useGame.getState();
  game.tags?.syncHouses('villagers', s.space === 'out' ? villagerHouseTags(game.objects('house'), s.villagersList) : [], (p) => game.scenes.out?.heightAt(p) ?? 0);
}
export const handlers: NetHandlers = {
  onSnapshot(snap, game) { useGame.getState().villagersApplySnapshot(snap); syncVillagerHouseTags(game); },
  onSpace(_space, game) {
    // G11: walking into another space ends any conversation you had open (the server ends its pause in the same space.enter).
    if (useGame.getState().villagersTalk) useGame.setState({ villagersTalk: null });
    syncVillagerHouseTags(game);
  },
  events: {
    'villager.paused': (e) => useGame.getState().villagersUpsertPause(e.pause),
    'villager.resumed': (e) => useGame.getState().villagersUpsertPause(e.pause),
    'villager.updated': (e, game) => { useGame.getState().villagersUpsert(e.v); syncVillagerHouseTags(game); },
    'villager.arrived': (e, game) => {
      useGame.getState().villagersUpsert(e.v);
      useGame.getState().toast('villagers.arrivedToast', { name: e.v.name });
      syncVillagerHouseTags(game);
    },
    'villager.left': (e, game) => {
      const v = useGame.getState().villagersList.find((x) => x.id === e.id);
      useGame.getState().villagersRemove(e.id);
      if (v) useGame.getState().toast('villagers.leftToast', { name: v.name });
      // G7: you were inside their house. The server lets you out at its plot door (hooks/space.ts), never into the sea.
      if (useGame.getState().space === villagerSpace(e.id)) void game.cmd.enterSpace('out');
      syncVillagerHouseTags(game);
    },
    'object.added': (_e, game) => syncVillagerHouseTags(game),          // a new villager's house (after the core handler added it)
    'object.updated': (_e, game) => syncVillagerHouseTags(game),
    'object.removed': (_e, game) => syncVillagerHouseTags(game),        // an evicted villager's house
  },
};
